import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';


@Component({
    selector: 'app-csr',
    templateUrl: './csr.component.html',
    styleUrls: ['./csr.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CsrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    gsap.registerPlugin(ScrollTrigger);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    // this.horizontalScroll()
  }
  isShown: boolean = false

  readText(){
    this.isShown = !this.isShown
  }

}
